import { render, staticRenderFns } from "./IconDislike.vue?vue&type=template&id=278e17c2&"
import script from "./IconDislike.vue?vue&type=script&lang=ts&"
export * from "./IconDislike.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports